import React, { useState, useEffect } from 'react';
import ApplyNow from './ApplyNow'; // Import the ApplyNowButton component

const NavbarSection = ({ onNavigate }) => {
  const [hasBorderShadow, setHasBorderShadow] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleEvent = () => {
      setHasBorderShadow(window.scrollY > 0 || window.innerWidth !== window.outerWidth);
    };
    window.addEventListener('scroll', handleEvent);
    window.addEventListener('resize', handleEvent);
    return () => {
      window.removeEventListener('scroll', handleEvent);
      window.removeEventListener('resize', handleEvent);
    };
  }, []);

  const toggleMenu = () => setMenuOpen((prev) => !prev);
  const closeMenu = () => setMenuOpen(false);

  const navLinks = [
    { label: 'Home', section: 'hero' },
    { label: 'About', section: 'about' },
    { label: 'Services', section: 'services' },
    { label: 'Courses', section: 'coursesOffer' },
    { label: 'Testimonial', section: 'testimonial' },
    { label: 'Contact', section: 'contact' },
  ];

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <header
      className={`text-[#060606] body-font fixed top-0 left-0 w-full z-50 bg-[#f5f6f8] ${
        hasBorderShadow ? 'shadow-md' : ''
      }`}
    >
      <div className="container mx-auto px-4 md:px-8 lg:px-16 flex items-center justify-between flex-wrap py-3">
        {/* Logo Section */}
        <div
          onClick={scrollToTop}
          className="flex title-font font-medium items-center text-gray-900 cursor-pointer ml-8"
        >
          <img
            src="/images/logo.png"
            alt="AlphaTech Logo"
            className="h-16"
          />
        </div>

        {/* Desktop Navigation Links */}
        <nav className="hidden md:flex space-x-4 items-center">
          {navLinks.map(({ label, section }) => (
            <button
              key={section}
              className="hover:text-[#e5a81b] hover:font-semibold cursor-pointer bg-transparent border-none text-sm md:text-base"
              onClick={() => onNavigate(section)}
            >
              {label}
            </button>
          ))}
          {/* Apply Now Button for Desktop */}
          <ApplyNow />
        </nav>

        {/* Hamburger Menu for Mobile */}
        <button
          className="md:hidden text-gray-500 focus:outline-none"
          onClick={toggleMenu}
        >
          <svg
            className="w-12 h-12" // Increased size of the menu icon
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            strokeWidth="2.5" // Increased stroke width for a bolder look
          >
            {menuOpen ? (
              <path d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>

        {/* Mobile Menu */}
        {menuOpen && (
          <div className="fixed top-0 left-0 w-full bg-white mt-20 md:hidden">
            <div className="flex flex-col items-start space-y-6 px-6 py-3">
              {navLinks.map(({ label, section }) => (
                <button
                  key={section}
                  className="text-black text-base hover:text-gray-600 cursor-pointer bg-transparent border-none"
                  onClick={() => {
                    closeMenu();
                    onNavigate(section);
                  }}
                >
                  {label}
                </button>
              ))}
              {/* Apply Now Button for Mobile */}
              <ApplyNow />
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default NavbarSection;
